// PagedTable.js  
import React, { useState, useEffect } from 'react';
import { Table, Pagination } from 'antd';
import './index.scss';
import background from 'asset/img/bk-person.webp';
import avator from 'asset/img/avator.webp';
import back from 'asset/img/back.png';
import record from 'asset/img/record.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { getRecordAllrecord, getUserInfo } from 'network';
import { formatTimeHM, formatDateYMD, formatDateHMS, serialName } from 'utils';

const Record = () => {
    const [data, setData] = useState([]);
    const [info, setInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 1,
    });
    let navigate = useNavigate();
    // 页面类型
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type');

    useEffect(() => {
        getRecordAllrecord({ page: pagination.current, size: pagination.pageSize }).then(res => {
            setData(res?.data)
        });
    }, [pagination.current, pagination.pageSize]);
    // console.log(data,'data')
    useEffect(() => {
        getUserInfo({}).then(res => {
            setInfo(res?.data)
        })
    }, []);

    const serialScore = (score) => {
        switch (score) {
            case 1:
                return <><span className="score-emoji">💪</span><span className="score-text">及格</span></>
            case 2:
                return <><span className="score-emoji">🎉</span><span className="score-text">优秀</span></>
            case 3:
                return <><span className="score-emoji">⭐</span><span className="score-text">满分</span></>
            default:
                return <><span className="score-emoji">💪</span><span className="score-text">及格</span></>
        }
    }

    // 表格列配置  
    const columns = [
        {
            title: '课程',
            dataIndex: 'serial_id',
            key: 'serial_id',
            render: (serial) => (
                <div className='serial'>
                    {serialName(serial)}
                </div>
            ),
        },
        {
            title: '关卡',
            dataIndex: 'number',
            key: 'number',
        },
        {
            title: '分值',
            dataIndex: 'score',
            key: 'score',
            render: (score) => (
                <div className={`score score-${score}`}>
                    {serialScore(score)}
                </div>
            ),
        },
        {
            title: '日期',
            dataIndex: 'done_time',
            key: 'done_time',
            render: (date) => (
                <div className='date'>
                    <div> {formatDateYMD(date)}</div>
                    <div className='date_item'> {formatDateHMS(date)}</div>
                </div>
            ),
        },
    ];

    // 分页变更处理函数  
    const handleTableChange = (pagination) => {
        setPagination(pagination);
    };

    const title = [
        {
            name: '学习总时长', content: 0,
        },
        {
            name: '今日学习时长', content: 0,
        },
        {
            name: '今日闯关数', content: 0,
        },
        {
            name: '总闯关数', content: 0,
        }
    ]

    // 根据积分获取对应的等级标签
    const getLevelTag = (score) => {
        const totalScore = score || 0;
        if (totalScore >= 15000) return { name: '至尊学神', emoji: '👑', color: 'linear-gradient(135deg, #FFD700 0%, #FF6B35 100%)', textColor: '#fff' };
        if (totalScore >= 12000) return { name: '传奇学霸', emoji: '🏆', color: 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)', textColor: '#7C2D12' };
        if (totalScore >= 9000) return { name: '知识大师', emoji: '🎓', color: 'linear-gradient(135deg, #A855F7 0%, #EC4899 100%)', textColor: '#fff' };
        if (totalScore >= 6000) return { name: '智慧精英', emoji: '💎', color: 'linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%)', textColor: '#fff' };
        if (totalScore >= 4000) return { name: '学霸之星', emoji: '⭐', color: 'linear-gradient(135deg, #F59E0B 0%, #EF4444 100%)', textColor: '#fff' };
        if (totalScore >= 2500) return { name: '闯关达人', emoji: '🔥', color: 'linear-gradient(135deg, #EF4444 0%, #F97316 100%)', textColor: '#fff' };
        if (totalScore >= 1500) return { name: '学习能手', emoji: '🚀', color: 'linear-gradient(135deg, #10B981 0%, #3B82F6 100%)', textColor: '#fff' };
        if (totalScore >= 800) return { name: '勤奋学员', emoji: '📚', color: 'linear-gradient(135deg, #14B8A6 0%, #22D3EE 100%)', textColor: '#fff' };
        if (totalScore >= 300) return { name: '小小学徒', emoji: '🌱', color: 'linear-gradient(135deg, #16A34A 0%, #65A30D 100%)', textColor: '#fff' };
        if (totalScore >= 50) return { name: '学习新手', emoji: '🎒', color: 'linear-gradient(135deg, #34D399 0%, #6EE7B7 100%)', textColor: '#065F46' };
        return { name: '萌新宝宝', emoji: '🐣', color: 'linear-gradient(135deg, #FBBF24 0%, #FDE68A 100%)', textColor: '#78350F' };
    };

    const levelTag = getLevelTag(info?.total_score);

    const handleBack = () => {
        navigate(`/home?type=${type}`);
    };
    // console.log(pagination.current, 'page')
    return (
        <div className='record-container'>
            <img src={back} className='record-back' onClick={handleBack} />
            <div className='record-title'><img src={record} /></div>
            <div className='record-header'>
                <div className='header-left'>
                    <div className='avator'>
                        <img src={info?.avatar || avator} alt="头像" onError={(e) => { e.target.src = avator; }} />
                    </div>
                    <div className='user-info'>
                        <div className='name'>{info?.name || '学员'}</div>
                        <div className='user-tag' style={{ background: levelTag.color, color: levelTag.textColor }}>
                            <span className='tag-emoji'>{levelTag.emoji}</span>
                            <span className='tag-name'>{levelTag.name}</span>
                        </div>
                    </div>
                </div>
                <div className='header-right'>
                    <div className='stat-item'>
                        <div className='stat-value'>{info?.total_score || 0}</div>
                        <div className='stat-label'>总积分</div>
                    </div>
                </div>
            </div>
            <div className='record-banner'>

                <div className='title-item' >
                    <div className='content'>{formatTimeHM(info?.total_sec)}</div>
                    <div className='name'>{'学习总时长'}</div>
                </div>
                <div className='title-item' >
                    <div className='content'>{formatTimeHM(info?.today_sec)}</div>
                    <div className='name'>{'今日学习时长'}</div>
                </div>
                <div className='title-item' >
                    <div className='content'>{info?.today_done_count}</div>
                    <div className='name'>{'今日闯关数'}</div>
                </div>
                <div className='title-item' >
                    <div className='content'>{info?.total_done_count}</div>
                    <div className='name'>{'总闯关数'}</div>
                </div>
            </div>
            <Table
                columns={columns}
                dataSource={data?.study_list}
                loading={loading}
                pagination={false}
                className='record-table'
                rowClassName="custom-table-row"
                rowKey="id"
                locale={{
                    emptyText: (
                        <div className='empty-state'>
                            <div className='empty-icon'>📚</div>
                            <div className='empty-text'>还没有学习记录哦</div>
                            <div className='empty-hint'>快去闯关吧，记录你的每一次进步！</div>
                        </div>
                    )
                }}
            />
            <div className='pagination-fixed'>
                <Pagination
                    current={pagination.current}
                    pageSize={10}
                    total={data?.total_count}
                    onChange={page => {
                        setPagination({ ...pagination, current: page });
                    }}
                />
            </div>
            <div className='record-background'>
                <img src={background} />
            </div>
        </div>
    );
};

export default Record;